import { migrateCourseUsersRequest } from '@/actions/room';
import ReadMore from '@/components/common/read-more';
import { Card, Skeleton, notification } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const AboutCard = ({
  description,
  room_type,
  course,
  isStaff,
  openSettings,
  members_count,
  slug,
  roommember,
  has_permission,
  loading,
}) => {
  const dispatch = useDispatch();
  const [migrateClick, setMigrateClick] = useState(false);

  const migrateCourseUsersStatus = useSelector(
    (state: any) => state.roomReducer.migrateCourseUsersStatus
  );
  useEffect(() => {
    return () => setMigrateClick(false);
  }, []);

  useEffect(() => {
    if (migrateClick && migrateCourseUsersStatus == 'success') {
      notification.success({
        message: 'Processing to migrate all users to the room.',
      });
      setMigrateClick(false);
    } else if (migrateCourseUsersStatus == 'failure') {
      notification.error({ message: 'Failed to migrate' });
    }
  }, [migrateCourseUsersStatus]);
  const migrateData = () => {
    setMigrateClick(true);
    dispatch(
      migrateCourseUsersRequest({
        data: { course: course.id, room: slug },
      })
    );
  };
  const handleOpen = (e) => {
    e.preventDefault();
    openSettings();
  };
  return (
    <>
      <Card
        className="about-card-room border-0"
        style={{
          borderRadius: '8px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        }}
      >
        <span
          className="mb-3 text-black"
          style={{ fontWeight: '700', fontSize: '16px' }}
        >
          About
        </span>
        {description && (
          <div
            className=" rounded-lg mt-2"
            style={{
              fontSize: '15px !important',
              fontWeight: '500',
            }}
          >
            <ReadMore text={description} style={{ color: 'black' }} />
          </div>
        )}
        {room_type === 1 && course && course?.tutor?.name && (
          <>
            <div className="mt-3 d-flex gap-3 align-items-center ">
              <i className="fas fa-chalkboard-teacher"></i>
              <div className="d-flex align-items-center gap-3">
                <span
                  className="text-black"
                  style={{
                    fontSize: '15px',
                    fontWeight: '600',
                  }}
                >
                  Tutor
                </span>
                <span
                  className="text-capitalize text-black"
                  style={{
                    fontSize: '15px',
                    fontWeight: '500',
                  }}
                >
                  {course?.tutor?.name}
                </span>
              </div>
            </div>
          </>
        )}
        <div className="mt-3 d-flex gap-3 align-items-center ">
          <>
            <i className="fas fa-list-ul"></i>
            <div className="d-flex align-items-center gap-3">
              <span
                className="text-black"
                style={{
                  fontSize: '15px',
                  fontWeight: '600',
                }}
              >
                Type
              </span>
              <span
                className="text-capitalize text-black"
                style={{
                  fontSize: '15px',
                  fontWeight: '500',
                }}
              >
                {room_type === 0 ? 'Public' : room_type === 1 && 'Private'}
              </span>
            </div>
          </>
        </div>
        <div className="mt-3 d-flex gap-3 align-items-center ">
          <i className="fas fa-user-friends"></i>
          <div className="d-flex align-items-center gap-3">
            <span
              className="text-black"
              style={{
                fontSize: '15px',
                fontWeight: '600',
              }}
            >
              Members
            </span>
            {loading ? (
              <Skeleton.Button />
            ) : (
              <span
                className="text-capitalize text-black"
                style={{
                  fontSize: '15px',
                  fontWeight: '500',
                }}
              >
                {members_count}
              </span>
            )}
          </div>
        </div>
        {roommember?.member_status == '1' ? (
          <>
            <div className="mt-3 d-flex gap-3 align-items-center ">
              <i className="fas fa-stopwatch" style={{ fontSize: '18px' }}></i>
              <div className="d-flex align-items-center gap-3">
                <span
                  className="text-black"
                  style={{
                    fontSize: '15px',
                    fontWeight: '600',
                  }}
                >
                  {' '}
                  Joined on
                </span>
                <span
                  className="text-black"
                  style={{
                    fontSize: '15px',
                    fontWeight: '500',
                  }}
                >
                  {moment(roommember?.joined_date).format('Do MMM, YYYY')}
                </span>
              </div>
            </div>
          </>
        ) : (
          ''
        )}
        {has_permission && course !== null && room_type === 1 && (
          <>
            <div className="mt-3 d-flex gap-3 align-items-center ">
              <i className="fas fa-chalkboard-teacher"></i>
              <div>
                <span
                  className="text-black"
                  style={{
                    fontSize: '15px',
                    fontWeight: '600',
                  }}
                >
                  Room Options
                </span>
                <br />
                <u
                  className="cursor-pointer text-black"
                  onClick={migrateData}
                  style={{
                    fontSize: '15px',
                    fontWeight: '500',
                  }}
                >
                  Migrate All Course Students
                </u>
              </div>
            </div>
          </>
        )}
      </Card>
    </>
  );
};

export default AboutCard;
